import React from 'react';
import IconosGenerales from '../iconos/IconosGenerales';
import Card from 'react-bootstrap/Card';
import styled from 'styled-components';
import ImagenDefault from './../../img/imgDefault.png';
import dayjs from 'dayjs';
import 'dayjs/locale/es';
import './draft-conver.css';


const ContenedorBlog = ({ publicacion }) => {

    console.log("curso ", publicacion);

    return (
      <>
        <CardCurso>
          <Card.Img
            variant="top"
            style={{ height: 400, objectFit: "cover" }}
            src={ 
              publicacion.imgPortada
                ? `${process.env.REACT_APP_API_URL}/api/comunicacion/blogs/imagen/${publicacion.Id}/${publicacion.imgPortada}`
                : ImagenDefault
            }
            onError={(e) => {
              e.target.src = ImagenDefault;
            }}
          />

          <CardHeader>
            <Card.Title>
              {dayjs(publicacion.fechaPublicacion, "YYYY-MM-DD")
                .format("DD/MM/YYYY")
                .replace(/^0/, "")
                .replace(/\/0(\d)\//, "/$1/")}
            </Card.Title>
          </CardHeader>
        </CardCurso>
        <EncabezadoCurso>
          <h1>{publicacion.titulo /*.replace(/-/g, " ")*/}</h1>
        <hr style={{ border: "1px solid #ccc", margin: "20px 0" }} />
        </EncabezadoCurso>

        <div
          className="contenido-html"
          dangerouslySetInnerHTML={{ __html: publicacion.contenido }}
        />
      </>
    );
}

export default ContenedorBlog;

const EncabezadoCurso = styled.div`
  
  margin-top: 10px;
    h1{
        font-size: 36px;
        font-weight: bold;
        text-transform: uppercase;
    }

    p{
        text-transform: capitalize;
        font-family: 'Montserrat';
        font-size: 17px;
        font-weight: 400;
        font-style: italic;
        line-height: 1em;   

    }

`


const CardCurso = styled(Card)`
    width: '90%' ;
    border: none !important;
`;
const CardHeader = styled(Card.Header)`
    border: none !important;
    margin-bottom: 10px !important;
`;


